var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-tab-content"},[_c('div',{staticClass:"title"},[_vm._v("积分兑换")]),_c('div',{staticClass:"content"},[_c('wt-form-table',{attrs:{"form":_vm.form},on:{"update:form":function($event){_vm.form=$event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }